module.exports = __webpack_public_path__ + "static/4-232cb49107e699b8866173fa2636abbe.png";